import React, { useState } from "react";
import { Box, FormControlLabel, Switch } from "@mui/material";
import ModalWrapper from "components/common/modals/modalWrapper/ModalWrapper";
import LetterTemplateForm from "./LetterTemplateForm";

const LetterTemplateManagementModal = ({
  isModalOpen,
  onClose,
  selectedTemplate,
}) => {
  const [active, setActive] = useState(selectedTemplate?.active ?? true);

  return (
    <ModalWrapper
      title={
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <span>{`${selectedTemplate ? "Update" : "Add"} Letter Template`}</span>
          <FormControlLabel
            sx={{ mr: 1 }}
            labelPlacement="start"
            control={
              <Switch
                color="secondary"
                checked={active}
                onChange={(e) => setActive(e.target.checked)}
              />
            }
            label="Active"
            componentsProps={{
              typography: {
                sx: { fontSize: "14px", fontWeight: 400, color: "#757575" },
              },
            }}
          />
        </Box>
      }
      titleStyle={{ flex: 1, marginRight: 8 }}
      show={isModalOpen}
      onClose={onClose}
      fullWidth
      maxWidth="lg"
      dialogProps={{
        sx: {
          "& .MuiDialogContent-root": {
            display: "flex",
            flexDirection: "column",
            height: "100%",
            padding: 0,
          },
        },
      }}
    >
      <LetterTemplateForm
        handleClose={onClose}
        selectedTemplate={selectedTemplate}
        isUpdate={!!selectedTemplate}
        active={active}
      />
    </ModalWrapper>
  );
};

export default LetterTemplateManagementModal;
